import { IIntent } from "@tylertech/tyler-api-types";

import { IntentHandler } from "./intentHandler";

export class Resolver
{
    constructor(pIntent: IIntent, pHandler: IntentHandler)
    {
        this.intent = pIntent;
        this.handler = pHandler;
    }

    intent: IIntent;
    handler: IntentHandler;
}


